import { useMemo } from 'react';
import useSWRImmutable from 'swr/immutable';
import { getHumidityMapsFromApi, getMapsFromApi, parseMaps } from '/@/store/maps/apiProviders';

export const useMaps = ({ country }) => {
    let key = {
        key: 'maps',
        country,
    };
    if (!country) key = null;
    return useSWRImmutable(key, getMapsFromApi);
};

export const useHumidityMaps = ({ country }) => {
    let key = {
        key: 'humidity-maps',
        country,
    };
    if (!country) key = null;
    return useSWRImmutable(key, getHumidityMapsFromApi);
};

export const useAllFormatedMaps = ({ country }) => {
    const mapsQuery = useMaps({ country });
    const humidityMapsQuery = useHumidityMaps({ country });

    const data = useMemo(() => {
        let allMaps = [];
        if (mapsQuery.data) {
            allMaps = allMaps.concat(parseMaps(mapsQuery.data));
        }
        if (humidityMapsQuery.data) {
            allMaps = allMaps.concat(humidityMapsQuery.data);
        }
        return allMaps;
    }, [mapsQuery.data, humidityMapsQuery.data]);

    return {
        data,
        isValidating: mapsQuery.isValidating || humidityMapsQuery.isValidating,
    };
};
